<template>
  <div>
    <defaultHeader :navIndex="1"></defaultHeader>
    <mobileHeader></mobileHeader>
    <boxTitle :imgUrl="imgUrl1" :imgTitle="imgTitle"></boxTitle>
    <!-- <div class="common-content">
      <div class="top-banner">
        <div class="img-bg" :style="{backgroundImage: 'url(' + imgUrl + ')'}">
          <div class="top-banner-text">自然与魔术的碰撞</div>
        </div>
      </div>
    </div> -->
    <div class="about-us" v-html="detail"></div>
    <div class="about-us-box">
      <div class="about-us-info">
        <img src="../../static/images/icon02.png" />
        <div class="english">OUR STORY</div>
        <div class="title">我们的故事</div>
        <div class="text">
          {{ articleAbstractDetail }}
        </div>
      </div>
    </div>
    <goBack></goBack>
    <defaulFooter></defaulFooter>
  </div>
</template>

<script>
import {menuList, articleDetail} from '@/api/xx-index'
import {infoList} from '@/api/index'
import defaultHeader from '../components/defaultheader.vue'
import mobileHeader from '../components/mobileheader.vue'
import defaulFooter from '../components/defaulfooter.vue'
import goBack from '@/components/goBack'
import boxTitle from '../components/boxTitle.vue'
const img = require('../../static/images/img12.jpg')
export default {
  components: {
    defaultHeader,
    defaulFooter,
    mobileHeader,
    goBack,
    boxTitle
  },
  name: 'aboutUs',
  data() {
    return {
      imgUrl: img,
      menuIds: '',
      listNav: [],
      articleId: '',
      detail: '',
      articleAbstractDetail: '',
      imgUrl1: '',
      imgTitle: ''
    }
  },
  created() {
    this.menuIds = window.location.href.split('=')[1]
    menuList({deptId: 112}).then(res => {
      console.log(res)
      this.listNav = res
      for (let i = 0; i < this.listNav.length; i++) {
        if (this.listNav[i].id == this.menuIds) {
          console.log(this.listNav[i])
          this.articleId = this.listNav[i].template.articleId
          this.imgUrl1 = this.listNav[i].menuBgimg
          this.imgTitle = this.listNav[i].menuBgimgTitle
          console.log(this.articleId)
        }
      }
      this.getDetail(this.articleId)
    })
    //公司基本信息数据
    infoList({deptId: 112}).then(res => {
      // console.log('公司基本信息', res)
      document.title = '关于我们-' + res.companyName + '-' + res.websiteDesc
    })
  },
  methods: {
    getDetail(articleId) {
      articleDetail({articleId: articleId}).then(res => {
        console.log(res)
        this.articleAbstractDetail = res.articleAbstract
        this.detail = res.articleValue
      })
    }
  }
}
</script>

<style>
.about-us {
  padding-top: 60px;
}
.about-us p {
  display: flex;
  justify-content: center;
}
</style>
